module.exports = updateSnapshot

const docToVanRecord = require('./tools/doc-to-van-record')
const {isInvalidSnapshot} = require('./validate/snapshot')
const { SHIPMENT_VERSIONS } = require('./constants')
const toDocIdProperties = require('./tools/to-doc-id-properties')
const toLocationProperties = require('./tools/to-location-properties')

async function updateSnapshot (state, options) {
  const {
    snapshotId,
    counts,
    shipmentTypeId,
    planningType,
    createdAt,
    createdBy,
    _rev,
    funderId,
    routeId,
    orderId,
    otpKey,
    externalShipmentId,
    dryRun = false,
    programId
  } = options

  const doc = {
    _id: snapshotId,
    type: 'snapshot',
    version: SHIPMENT_VERSIONS.VERSION_2,
    counts,
    shipmentTypeId,
    planningType,
    programId,
    funderId,
    routeId,
    orderId,
    createdAt: createdAt,
    createdBy: createdBy,
    updatedAt: new Date(),
    updatedBy: state.user.name,
    _rev: _rev
  }

  if (otpKey) doc.otpKey = otpKey

  if (externalShipmentId) doc.externalShipmentId = externalShipmentId

  const validationErrors = isInvalidSnapshot(doc)
  if (validationErrors) {
    throw new Error(validationErrors)
  }

  if (dryRun) return doc

  const { rev } = await state.dal.shipment.write(state, doc)
  doc._rev = rev

  // Extract locationId from snapshot's origin, or use state.user.location.id if available
  // This handles cases where state.user.location might be undefined (e.g., in updateRouteInCouchDB)
  let locationId
  if (state.user && state.user.location && state.user.location.id) {
    locationId = state.user.location.id
  } else {
    // Extract origin from doc._id as fallback
    const { origin } = toDocIdProperties(doc._id)
    const originProps = toLocationProperties(origin)
    locationId = originProps.id
  }

  // Pass user if available, otherwise undefined (docToVanRecord handles this)
  const user = state.user || undefined

  return docToVanRecord(doc, locationId, user)
}
